import { render, staticRenderFns } from "./EmptyWrapper.vue?vue&type=template&id=37580baa&"
import script from "./EmptyWrapper.vue?vue&type=script&lang=js&"
export * from "./EmptyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports